// apps/embed/config/popper/createPopper.js
//
// The embed's `@popperjs/core` (craco.config.js aliases the package to this module): Popper as it is, with
// `createPopper` built from only the modifiers MUI's components use. MUI's Popper (Popper/BasePopper.js, the one
// importer) configures preventOverflow and flip and adds its own onUpdate; Tooltip adds arrow. Left out:
//   - `offset`: nothing sets it, and its default [0, 0] moves nothing (flip and preventOverflow read an offset of
//     0 without it);
//   - `hide`: it only writes data-popper-reference-hidden and data-popper-escaped, which no style reads.
// main.js −1.3 KB, and as much in each other widget. A widget that configured either by name would have it
// ignored without a word, so apps/embed/src/entries/buildStandIns.test.ts keeps them out of the widgets' code.
// Everything else the package exports is re-exported unchanged.
import { popperGenerator } from '@popperjs/core/lib/createPopper.js';
import applyStyles from '@popperjs/core/lib/modifiers/applyStyles.js';
import arrow from '@popperjs/core/lib/modifiers/arrow.js';
import computeStyles from '@popperjs/core/lib/modifiers/computeStyles.js';
import eventListeners from '@popperjs/core/lib/modifiers/eventListeners.js';
import flip from '@popperjs/core/lib/modifiers/flip.js';
import popperOffsets from '@popperjs/core/lib/modifiers/popperOffsets.js';
import preventOverflow from '@popperjs/core/lib/modifiers/preventOverflow.js';

export * from '@popperjs/core/lib/index.js';

// Popper's own default list (lib/popper.js) in its order, without offset and hide.
export const createPopper = /*#__PURE__*/ popperGenerator({
	defaultModifiers: [eventListeners, popperOffsets, computeStyles, applyStyles, flip, preventOverflow, arrow],
});
